"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IBboxPoint = void 0;
var utils_1 = require("../../../utils");
var bbox_1 = require("./bbox");
/**
 * @description bboxの点のデータ
 */
exports.IBboxPoint = (0, utils_1.IRecord)({
    type: 'point',
    location: 'nw',
    centerPos: (0, utils_1.IPos)(),
    parent: (0, bbox_1.IBbox)()
});
